export const whatsappMessage = `Hola Angelita,\n
He visitado tu página web y me interesa comenzar terapia contigo. Me gustaría obtener más información sobre tus servicios.\n
Gracias.
`

export const DISCOUNTS = [
    'Sin descuento',
    '30% Off desde la 2da compra'
]